import { LiveApi, Api } from "@/services/Api";

export default {
  listLocales(data) {
    return LiveApi().post("common/locales", data);
  },
  getSiteMode(data) {
    return Api().get("common/site-mode", data);
  },
  getexchangeRates() {
    return Api().get("common/exchange-rates");
  }
};
